import React from "react";
import { connect } from "react-redux";
import { UserState } from "../../redux/modules/user/reducer";
import { AppDispatch } from "../../store";
import { userClicksLogoutButton } from "./logoutButtonScenarios";
import { GlobalState } from "../../redux/modules/rootReducer";
import NavItem from "../components/NavBar/NavItem";
import NavLabel from "../components/NavBar/NavLabel";
import LogoutIcon from "./LogoutIcon";

type Props = {
  dispatch: AppDispatch;
  userState: UserState;
};
export default connect((state: GlobalState) => ({
  userState: state.user,
}))(({ userState, dispatch }: Props) => (
  <NavItem
    icon={<LogoutIcon onClick={() => dispatch(userClicksLogoutButton())} />}
    content={<NavLabel label={userState.name || userState.email} />}
  />
));
